import Axios from 'axios'
import { toggleDefaultData } from './toggle'
var qs = require('qs')

const upload = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  sendFile (file) {
    let formData = new FormData()

    formData.append('name', file)
    return this.axios().post('/order/upload', formData)
  },
  getFilesSent (startDate, endDate, idLaboratory, stateList) {
    return this.axios().get('/order/upload/files-sent', {
      params: {
        startDate: startDate,
        endDate: endDate,
        idLaboratory: idLaboratory,
        stateList: stateList
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false })
      }
    })
  },
  updateOrderDuplicatedBeforeTransfered (idOrder) {
    return this.axios().post('/order/validate-order/' + idOrder)
  },
  updateOrderDuplicatedAfterTransfered (order) {
    const toggleData = toggleDefaultData()
    return this.axios().put('/order/maintenance/upload/', order, {
      params: {
        asyncBatch: toggleData?.feature.nonSegregatedBatchList
      }
    })
  },
  deleteOrderDuplicated (idOrder, exams) {
    return this.axios().delete('/order/' + idOrder + '/exam', { data: exams })
  },
  deleteFile (id) {
    return this.axios().delete('/order/upload/files-removal', {
      params: {
        idFile: id
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false })
      }
    })
  }
}

export default upload
